import React from 'react';
import './MentionAvatars.scss';
import { Tooltip } from 'primereact/tooltip';
import BrandIcon from '../../../../../../../shared/components/brand-icon/BrandIcon';

const MAX_VISIBLE = 4;

interface MentionAvatarsProps {
  /** Resolved brand labels mentioned in the bucket, best first. */
  brands: string[];
  /** Resolved label → series color (keeps avatars consistent with the charts). */
  colorByName: Map<string, string>;
  /** Unique id fragment for the overflow tooltip target. */
  tooltipId: string;
}

/** Stacked brand initials for the MENTIONS column; overflow collapses into a "+N" with a tooltip. */
const MentionAvatars: React.FC<MentionAvatarsProps> = ({ brands, colorByName, tooltipId }) => {
  if (brands.length === 0) {
    return <>-</>;
  }

  const visible = brands.slice(0, MAX_VISIBLE);
  const hidden = brands.slice(MAX_VISIBLE);
  const overflowId = `mention-overflow-${tooltipId}`;

  return (
    <div className="mention-avatars">
      {visible.map((brand) => {
        const itemId = `mention-item-${tooltipId}-${brand.replace(/\W/g, '')}`;
        return (
          <span key={brand} id={itemId} className="mention-avatars__item">
            <BrandIcon name={brand} color={colorByName.get(brand)} size="xs" />
            <Tooltip
              target={`#${itemId}`}
              className="tooltip--top"
              position="top"
              showDelay={5}
              appendTo={document.body}
            >
              {brand}
            </Tooltip>
          </span>
        );
      })}
      {hidden.length > 0 && (
        <>
          <span id={overflowId} className="mention-avatars__more">
            +{hidden.length}
          </span>
          <Tooltip
            target={`#${overflowId}`}
            className="tooltip--top"
            position="top"
            showDelay={5}
            appendTo={document.body}
          >
            {hidden.join(', ')}
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default MentionAvatars;
